/* CARBO V5 · Nuggets: genau EINE Instanz der Versand-Widgets.
   Verschiebt existierende DOM-Nodes auf Desktop nach dem Produktgrid.
   Auf Mobilgeräten bleiben sie in der originalen Buybox. */
(() => {
  'use strict';
  const KEY = '__tpNuggetsDesktopMoveV1';
  if (window[KEY]) { window[KEY].refresh(); return; }

  const mq = window.matchMedia('(min-width: 750px)');
  const records = new WeakMap();

  function getRecord(mount) {
    const cached = records.get(mount);
    if (cached) return cached;
    const section = mount.closest('.product-information');
    if (!section) return null;
    const details = section.querySelector('.product-details');
    if (!details) return null;

    const shipping = details.querySelector('[data-tp-buybox-availability]');
    const aftercare = details.querySelector('[data-tp-buybox-aftercare]');
    const transport = details.querySelector('tp-transportbox-details');
    if (!shipping || !aftercare) return null;
    const shippingNode = shipping.parentElement;
    const aftercareNode = aftercare.parentElement;
    const transportNode = transport ? transport.parentElement : null;
    if (!shippingNode || !aftercareNode || shippingNode === aftercareNode) return null;

    const shipTarget = mount.querySelector('[data-tp-nuggets-shipping]');
    const afterTarget = mount.querySelector('[data-tp-nuggets-aftercare]');
    const transportTarget = mount.querySelector('[data-tp-nuggets-transport]');
    if (!shipTarget || !afterTarget || !transportTarget) return null;

    const shipMarker = document.createComment('tp-nuggets-shipping-original');
    const afterMarker = document.createComment('tp-nuggets-aftercare-original');
    shippingNode.parentNode.insertBefore(shipMarker, shippingNode);
    aftercareNode.parentNode.insertBefore(afterMarker, aftercareNode);
    const transportMarker = transportNode ? document.createComment('tp-nuggets-transport-original') : null;
    if (transportMarker) transportNode.parentNode.insertBefore(transportMarker, transportNode);
    mount.classList.toggle('tp-nuggets-postbuy--no-transport', !transportNode);
    const record = {
      shippingNode, aftercareNode, transportNode,
      shipMarker, afterMarker, transportMarker,
      shipTarget, afterTarget, transportTarget, moved: false
    };
    records.set(mount, record);
    return record;
  }

  function restore(node, marker) {
    if (marker.parentNode) marker.parentNode.insertBefore(node, marker.nextSibling);
  }

  function refresh() {
    for (const mount of document.querySelectorAll('[data-tp-nuggets-layout]')) {
      const item = getRecord(mount);
      if (!item) { mount.hidden = true; continue; }
      if (mq.matches) {
        if (!item.moved) {
          item.shipTarget.appendChild(item.shippingNode);
          item.afterTarget.appendChild(item.aftercareNode);
          if (item.transportNode) item.transportTarget.appendChild(item.transportNode);
          item.moved = true;
        }
        mount.hidden = false;
      } else {
        if (item.moved) {
          restore(item.shippingNode, item.shipMarker);
          restore(item.aftercareNode, item.afterMarker);
          if (item.transportNode) restore(item.transportNode, item.transportMarker);
          item.moved = false;
        }
        mount.hidden = true;
      }
    }
  }

  window[KEY] = { refresh };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }
  if (mq.addEventListener) mq.addEventListener('change', refresh);
  else mq.addListener(refresh);
  document.addEventListener('shopify:section:load', refresh);
})();
